// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"ef250f65","884":"6e5aba0c","894":"bcc7a983"}[chunkId] + ".chunk.css";
};